import { render } from "./MedicationSearch.vue?vue&type=template&id=190b160c&ts=true"
import script from "./MedicationSearch.vue?vue&type=script&lang=ts"
export * from "./MedicationSearch.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__